<app-page>
  <app-terms-of-service></app-terms-of-service>
</app-page>
